module.exports = __webpack_public_path__ + "img/bagging_ilust_dg_woodpacking_en.f3ebbb03.svg";